/**
 * getDisplayValuation
 * -------------------
 * Single source of truth für den Preis, der dem Kunden als "Geschätzter
 * (Verkaufs-)Preis" angezeigt wird.
 *
 * Bevorzugt den EK/Ankaufswert (valuationEngine.purchaseOffer), fällt auf den
 * bisherigen Marktwert (carData.price + marketRange) zurück, wenn kein
 * vollständiges purchaseOffer vorliegt (manueller/Legacy-Flow, Fahrzeuge ohne
 * EK). Die Fallback-Semantik ist bewusst identisch zur ursprünglichen
 * Inline-Logik in preis/[id]/FIN.js.
 *
 * WICHTIG: Nur für die ANZEIGE des geschätzten Preises verwenden. NICHT für
 * Flow-/Routing-Guards (die prüfen weiterhin roh carData.price) und NICHT für
 * andere Preis-Semantiken (Richtpreis/minPrice, Höchstgebot/auction.finalPrice,
 * Wertverlust-Historie).
 *
 * @param {object|null|undefined} carData
 * @returns {{price:any, rangeLow:any, rangeHigh:any, useOffer:boolean}}
 */
export function getDisplayValuation(carData) {
  const purchaseOffer = carData?.valuationEngine?.purchaseOffer;
  const useOffer =
    Number(purchaseOffer?.value) > 0 &&
    Number(purchaseOffer?.low) > 0 &&
    Number(purchaseOffer?.high) > 0;

  return {
    price: useOffer ? purchaseOffer.value : carData?.price,
    rangeLow: useOffer
      ? purchaseOffer.low
      : carData?.valuationEngine?.marketRange?.low,
    rangeHigh: useOffer
      ? purchaseOffer.high
      : carData?.valuationEngine?.marketRange?.high,
    useOffer,
  };
}

export default getDisplayValuation;
